import { getAngularJsService, goto } from '../../Js/React/Services/legacy';
import BizCarousel from '../../Js/React/UI/BizCarousel/BizCarousel';
import useWindowSize from '../../FrontEndReact/src/Core/Hooks/useWindowSize';

//todo translation, add i18n in react?

export interface ListObject {
	Id: number;
	Name: string;
	Description: string;
	ImageUrl: string;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	EngageObjects: any[];
	Url?: { state: string; params?: Record<string, string | number> };
	OverrideTypeLabel?: string;
	OverrideTypeLabels?: ObjectTypeLabelProps[];
	BannerText?: string;
}

const LAYOUTS = ['hero', 'row', 'carousel']; //todo: row implementation
const DEFAULT_LAYOUT = 'hero';
const DEFAULT_LIMIT = 3;

export type ObjectType = 'JOURNEY' | 'EVENT' | 'BLOG';
const DEFAULT_OBJECT_TYPE: ObjectType = 'JOURNEY';

interface ObjectMiniListProps {
	objects: ListObject[];
	layout?: string;
	layoutMobile?: string;
	limit?: number;
	type?: ObjectType;
}

interface OneListObjectProps {
	obj: ListObject;
	type: ObjectType;
}

type ObjectTypeLabelProps = {
	type: ObjectType;
	overrideLabel?: string;
	overrideIcon?: string;
	index?: number;
};

const ObjectTypeLabel = ({ type, overrideLabel, overrideIcon, index }: ObjectTypeLabelProps) => {
	//todo translations and more item type support

	const labelIndex = 'label-index-' + (index ?? 0);
	let iconClass = 'fas fa-hiking';
	let typeName = 'Resa';

	if (type === 'EVENT') {
		iconClass = 'fas fa-calendar-alt';
		typeName = 'Event';
	} else if (type === 'BLOG') {
		iconClass = 'fas fa-newspaper';
		typeName = 'Artikel';
	}

	iconClass = overrideIcon !== undefined && overrideIcon.length >= 0 ? overrideIcon : iconClass;

	return (
		<div className={`one-item-type-name ${labelIndex}`}>
			<span>{overrideLabel ?? typeName}</span>
			{iconClass && <i className={iconClass}></i>}
		</div>
	);
};

const OneListObject = ({ obj, type }: OneListObjectProps) => {
	const { isMobile } = useWindowSize();

	const bizJourneyService = getAngularJsService('bizJourneyService');
	const baseService = getAngularJsService('base.service');

	const getSiteRootPath = (url: string) => {
		return baseService.GetSiteRootPath(url);
	};

	//cannot get uirouter working with a link here, so we have to do it this way for now
	const objectClickHandler = () => {
		//todo: set state/params on each object so it works on other types than journeys
		if (obj.Url) {
			//console.log('go to', obj.Url.state, obj.Url.params);
			goto(obj.Url.state, obj.Url.params);
		} else if (obj.EngageObjects.length > 0) {
			bizJourneyService.GoToEngageItem(obj.EngageObjects[0]);
		} else {
			console.log('cannot go to first item in journey, as there isnt any items journey');
		}
	};

	//console.log('one object', obj);

	return (
		<div className={`mini-list-object${obj.BannerText ? ' has-banner' : ''}`} onClick={objectClickHandler}>
			{!!obj.BannerText && (
				<div className='banner'>
					<span className='banner-text'>{obj.BannerText}</span>
				</div>
			)}
			<div
				className='image'
				style={{
					backgroundImage: `url(${getSiteRootPath(obj.ImageUrl)})`,
				}}
			></div>
			{!obj.OverrideTypeLabels && <ObjectTypeLabel type={type} overrideLabel={obj.OverrideTypeLabel}></ObjectTypeLabel>}
			{obj.OverrideTypeLabels?.map((l, index) => (
				<ObjectTypeLabel
					key={index}
					type={l.type}
					overrideLabel={l.overrideLabel}
					overrideIcon={l.overrideIcon}
					index={index}
				></ObjectTypeLabel>
			))}
			<div className='information'>
				<h3 className='line-limit lines-2'>{obj.Name}</h3>
				<p className='line-limit lines-2'>{obj.Description}</p>
				<span onClick={objectClickHandler} className={`read-more ${isMobile ? 'biz-btn biz-primary' : ''}`}>
					Läs mer
				</span>
				<div></div>
			</div>
		</div>
	);
};

const ObjectCarousel = ({ objects, type }: ObjectMiniListProps) => {
	console.log('carusel', objects);
	return (
		<BizCarousel
			settings={{
				arrows: false,
				autoplay: false,
				dots: false,
				infinite: false,
				slidesToScroll: 1,
				slidesToShow: objects.length > 1 ? 1.05 : 1,
				centerMode: objects.length > 1 ? true : false,
				centerPadding: objects.length > 1 ? '1%' : undefined,
			}}
		>
			{objects.map((obj) => (
				<OneListObject obj={obj} key={obj.Id} type={type || DEFAULT_OBJECT_TYPE}></OneListObject>
			))}
		</BizCarousel>
	);
};

const ObjectMiniList = ({ objects, layout, layoutMobile, limit, type }: ObjectMiniListProps) => {
	const { isMobile } = useWindowSize();

	const getRowLimit = (layout, listLimit) => {
		if (layout === 'row' && listLimit > 4) {
			return 4;
		}
		if (layout === 'hero' && listLimit > 4) {
			return DEFAULT_LIMIT;
		}

		return DEFAULT_LIMIT;
	};

	const listLayout = LAYOUTS.find((l) => l.toLowerCase() === layout?.toLowerCase()) ?? DEFAULT_LAYOUT;
	const listLimit = limit ?? DEFAULT_LIMIT;
	const rowLimit = getRowLimit(layout, listLimit);

	const containerClass = 'object-mini-list ' + listLayout + '-' + rowLimit;

	if (layout === 'carousel' || (isMobile && layoutMobile === 'carousel')) {
		return (
			<div className={containerClass}>
				<ObjectCarousel objects={objects} limit={listLimit} type={type || DEFAULT_OBJECT_TYPE} />
			</div>
		);
	}

	if (layout === 'row') {
		return (
			<div className={containerClass}>
				{objects.slice(0, listLimit).map((obj) => (
					<OneListObject obj={obj} key={obj.Id} type={type || DEFAULT_OBJECT_TYPE}></OneListObject>
				))}
			</div>
		);
	}

	return (
		<>
			<div className={containerClass}>
				{objects.slice(0, isMobile ? listLimit : rowLimit).map((obj) => (
					<OneListObject obj={obj} key={obj.Id} type={type || DEFAULT_OBJECT_TYPE}></OneListObject>
				))}
			</div>
			{!isMobile && listLimit > objects.length - rowLimit && (
				<div className='object-mini-list row-4'>
					{objects.slice(rowLimit, listLimit).map((obj) => (
						<OneListObject obj={obj} key={obj.Id} type={type || DEFAULT_OBJECT_TYPE}></OneListObject>
					))}
				</div>
			)}
		</>
	);
};

export default ObjectMiniList;
